export const sellItemIds = {
    /**
     * just a regular internal job. promotion is 0
     */
    regularJob: 'regular-job',
    /**
     * promoted job, with promotion 1 (in jobs table)
     */
    promotedJob: 'promoted-job',
    subscriptionStarterMonthly: 'job-slots-1-monthly',
    subscriptionStarterAnnual: 'job-slots-1-annual',
    subscriptionProMonthly: 'job-slots-4-monthly',
    subscriptionProAnnual: 'job-slots-4-annual',
    subscriptionBusinessMonthly: 'subscription-business-monthly',
    subscriptionBusinessAnnual: 'subscription-business-annual',
    credits: 'credits',
} as const;

export type SellItemIdsKeys = keyof typeof sellItemIds;
export type SellItemIdsValues = typeof sellItemIds[SellItemIdsKeys]

export const sellItems = {
    [sellItemIds.subscriptionStarterMonthly]: {
        id: sellItemIds.subscriptionStarterMonthly,
        unitprice: 180,
        description: 'משרה אחת חודשי',
        jobs: 1,
        calculateDiscount(_quantity: number) {
            return sellItems[sellItemIds.subscriptionStarterMonthly].unitprice;
        },
    },
    [sellItemIds.subscriptionStarterAnnual]: {
        id: sellItemIds.subscriptionStarterAnnual,
        unitprice: 1620,
        description: 'משרה אחת שנתי',
        jobs: 1,
        calculateDiscount(_quantity: number) {
            return sellItems[sellItemIds.subscriptionStarterAnnual].unitprice;
        },
    },
    [sellItemIds.subscriptionProMonthly]: {
        id: sellItemIds.subscriptionProMonthly,
        unitprice: 440,
        description: '4 משרות חודשי',
        jobs: 4,
        calculateDiscount(_quantity: number) {
            return sellItems[sellItemIds.subscriptionProMonthly].unitprice;
        },
    },
    [sellItemIds.subscriptionProAnnual]: {
        id: sellItemIds.subscriptionProAnnual,
        unitprice: 3960,
        description: '4 משרות שנתי',
        jobs: 4,
        calculateDiscount(_quantity: number) {
            return sellItems[sellItemIds.subscriptionProAnnual].unitprice;
        },
    },
    [sellItemIds.subscriptionBusinessMonthly]: {
        id: sellItemIds.subscriptionBusinessMonthly,
        unitprice: 899,
        description: 'מנוי עסקי חודשי',
        jobs: 10,
        calculateDiscount(_quantity: number) {
            return sellItems[sellItemIds.subscriptionBusinessMonthly].unitprice;
        },
    },
    [sellItemIds.subscriptionBusinessAnnual]: {
        id: sellItemIds.subscriptionBusinessAnnual,
        unitprice: 8990,
        description: 'מנוי עסקי שנתי',
        jobs: 10,
        calculateDiscount(_quantity: number) {
            return sellItems[sellItemIds.subscriptionBusinessAnnual].unitprice;
        },
    },
    [sellItemIds.regularJob]: {
        id: sellItemIds.regularJob,
        unitprice: 190,
        jobs: 1,
        description: 'פרסום משרה',
        calculateDiscount(quantity: number) {
            if (quantity <= 2) return sellItems[sellItemIds.regularJob].unitprice;
            if (quantity <= 4) return 170;
            if (quantity <= 9) return 150;
            return 140;
        },
    },
    [sellItemIds.promotedJob]: {
        id: sellItemIds.promotedJob,
        unitprice: 290,
        jobs: 1,
        description: 'פרסום משרה מקודמת',
        calculateDiscount(quantity: number) {
            if (quantity <= 2) return sellItems[sellItemIds.promotedJob].unitprice;
            if (quantity <= 4) return 250;
            if (quantity <= 9) return 230;
            return 210;
        },
    },
} as const;
